import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-class',
  templateUrl: './class.component.html',
  styleUrls: ['./class.component.scss']
})
export class ClassComponent implements OnInit {

  @Input() classForm!: FormGroup;
  @Input() expanded = false;

  get studentFormsValue() {
    return (this.classForm?.get('students') as FormArray).value || [];
  }
  get studentFormsControl() {
    return (this.classForm?.get('students') as FormArray).controls || [];
  }
  get name() {
    return this.classForm?.get('name')?.value || '';
  }
  get dirtyForms() {
    return this.studentFormsControl.filter(form => form.dirty && !form.get('record')?.get('isSubmitted')?.value);
  }

  get submittedForms() {
    return this.studentFormsControl.filter(form => {
      const record = form.get('record');
      return record?.get('isSubmitted')?.value;
    });
  }


  constructor() { }

  ngOnInit(): void {
    this.submittedForms;
  }

  clickExpand() {
    this.expanded = !this.expanded;
  }

}
